__turbopack_context__.v({
  "panel": "header-panel-module__cWU9Ja__panel",
});
